import * as actions from 'redux/actions/search.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as serpCheckerActions from 'redux/actions/serpChecker.actions'
import * as keywordFinderActions from 'redux/actions/keywordFinder.actions'
import * as backlinkCheckerActions from 'redux/actions/backlinkChecker.actions'
import { query } from 'helpers/util'

const initialState = {
  value: query?.keyword || query?.url || '',
  location: query?.location || 'GLOBAL',
  language: query?.language || '',
  languages: [],
  depth: query?.depth || 500,
  device: query?.device || 'desktop',
  type: query?.type || '',
  error: ''
}

const searchReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.setValue.type:
      return {
        ...state,
        value: payload.value || ''
      }
    case actions.setLocation.type:
      return {
        ...state,
        location: payload.location || '',
        language: payload.language || '',
        languages: payload.languages || []
      }
    case actions.setLanguages.type:
      return {
        ...state,
        language: payload.language || '',
        languages: payload.languages || []
      }
    case actions.setLanguage.type:
      return {
        ...state,
        language: payload.language || ''
      }
    case actions.setDevice.type:
      return {
        ...state,
        device: payload.device || ''
      }
    case actions.setDepth.type:
      return {
        ...state,
        depth: payload.depth || ''
      }
    case actions.setType.type:
      return {
        ...state,
        type: payload.type || ''
      }

    // Set every custom field with one action, i.e.: in history load
    case actions.setSearch.type:
      return {
        ...state,
        ...payload.payload
      }
    // Fill on SERP Checker history load
    case serpCheckerActions.loadSerpCheckerPreviousSuccess.type:
      return {
        ...state,
        value: payload.data.attributes.word,
        location: payload.data.attributes.locationAlpha2,
        language: payload.data.attributes.language,
        device: payload.data.attributes.device,
        type: payload.data.attributes.type,
      }
    // Fill on KeywordFinder history load
    case keywordFinderActions.loadPreviousSuccess.type:
      return {
        ...state,
        value: payload.data.attributes.word,
        type: payload.data.attributes.type,
        language: payload.data.attributes.language,
        location: payload.data.attributes.location,
      }
    case backlinkCheckerActions.loadPreviousSuccess.type:
      return {
        ...state,
        value: payload.url || '',
        depth: payload.depth || 500,
        type: payload.filter || 'all'
      }

    case actions.setError.type:
      return {
        ...state,
        error: payload.error || '',
      }

    case 'ROUTE_CHANGE':
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState

    default:
      return state
  }
}

export default searchReducer
